import Amplify from 'aws-amplify';

export default Amplify.configure({
    Auth: {
      // T*PLATS開発環境用
      // // REQUIRED - Amazon Cognito Identity Pool ID
      // identityPoolId: 'ap-northeast-1:183538135238:',
      // // // REQUIRED - Amazon Cognito Region
      // region: 'ap-northeast-1',
      // // OPTIONAL - Amazon Cognito User Pool ID
      // userPoolId: 'ap-northeast-1_kG2jS1ktX',
      // // OPTIONAL - Amazon Cognito Web Client ID
      // userPoolWebClientId: '44obkgj1fjk3cbakk046fc6cs3',
      // mandatorySignIn: true

      // T*PLATSステージング環境用
      // // REQUIRED - Amazon Cognito Identity Pool ID
      // identityPoolId: 'ap-northeast-1:971037905358:',
      // // REQUIRED - Amazon Cognito Region
      // region: 'ap-northeast-1',
      // // OPTIONAL - Amazon Cognito User Pool ID
      // userPoolId: 'ap-northeast-1_xFCU9KPrY',
      // // OPTIONAL - Amazon Cognito Web Client ID
      // userPoolWebClientId: '518tmefccj73dgl1j1o5k4h8m9',
      // mandatorySignIn: true

      // T*PLATS本番環境用
      // REQUIRED - Amazon Cognito Identity Pool ID
      identityPoolId: 'ap-northeast-1:979732773990:',
      // REQUIRED - Amazon Cognito Region
      region: 'ap-northeast-1',
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'ap-northeast-1_7CXASSOno',
      // OPTIONAL - Amazon Cognito Web Client ID
      userPoolWebClientId: '5h84tni1cd5r9vtvc3fu82h5mn',
      mandatorySignIn: true
    },
    API: {
        endpoints: [
            // T*PLATS開発環境用
            // {
            //   name: 'BuildingPOC',
            //   endpoint:  'https://89valp9n80.execute-api.ap-northeast-1.amazonaws.com/api',
            //   region: 'ap-northeast-1'
            // }
            // // T*PLATSステージング環境用
            // {
            //   name: 'BuildingPOC',
            //   endpoint:  'https://eqtnq17h6c.execute-api.ap-northeast-1.amazonaws.com/api',
            //   region: 'ap-northeast-1'
            // }
            // T*PLATS本番環境用
            {
              name: 'BuildingPOC',
              endpoint:  'https://zcmd1szv64.execute-api.ap-northeast-1.amazonaws.com/api',
              region: 'ap-northeast-1'
            }
        ]
    },
    Analytics: {
      disabled: true
    }
});
